import { Step, StepLabel, Stepper } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Form, ProgressBar } from "react-bootstrap";
import PersonalDetail from "./PersonalDetail";
import { HiOutlineArrowLeft } from "react-icons/hi";
import CarDetail from "./CarDetail";
import CarFeature from "./CarFeature";
import RentCharges from "./RentCharges";
import { useDispatch, useSelector } from "react-redux";
import {
  addCar,
  cleanAddCarData,
  cleanData,
  clearCarImagesResponse,
  clearEditCarID,
  decreaseStep,
  editCar,
  getCarModal,
} from "../../redux/Slice/formSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import Swal from "sweetalert2";
// import MoonLoader from  "react-spinners/ClipLoader"
const MultiStepForm = () => {
  const dispatch = useDispatch();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const step = useSelector((state) => state?.form?.step);
  // const userInfo = useSelector((state) => state?.form?.PersonalDetails);
  const carDetails = useSelector((state) => state?.form?.carDetails);
  const PersonalDetails = useSelector((state) => state?.form?.PersonalDetails);
  const driverDetails = useSelector((state) => state?.form?.driverDetails);
  const carInsurance = useSelector((state) => state?.form?.carInsurance);
  const location = useSelector((state) => state?.form?.location);
  const addCarData = useSelector((state) => state?.form?.addCarData);
  const editCarID = useSelector((state) => state?.form?.editCarID);
  const gpsPayment = useSelector((state) => state?.auth?.gpsPayment);
  const { carImagesResponse } = useSelector((state) => state?.form);
  const [carDetail, setCarDetail] = useState(carDetails);
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const editCarResponse = useSelector((state) => state?.form?.editCarResponse);
  const [base64Data, setBase64Data] = useState({});
  // let base64Data = {}
  const [personalDetail, setPersonalDetail] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    identityFront: "",
    identityBack: "",
    userCountryCode: "",
    userPhoneNumber: "",
  });
  const [addResp, setAddResp] = useState({});

  const [features, setFeatures] = useState({
    airConditioner: "",
    childSeat: "",
    music: "",
    saftyGear: "",
    gpsNavigation: "",
    manual: "",
    automatic: "",
  });

  const [driverDetail, setDriverDetail] = useState({
    fullName: "",
    age: "",
    phone: "",
    email: "",
    IDfront: "",
    IDback: "",
    licenceImg: "",
    licenceIssueDate: "",
  });

  // const [file, setFile] = useState(null);
  // const handleChange = (file) => {
  //   setFile(file);
  // };

  // const handleAddCar = () => {};

  const [btnStatus, setBtnStatus] = useState(false);

  useEffect(() => {
    if (PersonalDetails) {
      setPersonalDetail({
        ...personalDetail,
        identityFront: PersonalDetails.identityFront
          ? PersonalDetails.identityFront
          : userDetail?.data?.identityFront,
        identityBack: PersonalDetails.identityBack
          ? PersonalDetails?.identityBack
          : userDetail?.data?.identityBack,
        // phone: userDetail?.data?.phoneNumber,
        phone:
          "+" + userDetail?.data?.country_code + userDetail?.data?.phoneNumber,
        userCountryCode: userDetail?.data?.country_code,
        userPhoneNumber: userDetail?.data?.phoneNumber,
        userId: userDetail?.data?._id,
        fullName: userDetail?.data?.name,
        email: userDetail?.data?.emailId,
        address: PersonalDetails?.address
          ? PersonalDetails?.address
          : userDetail?.data?.address,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, PersonalDetails]);

  useEffect(() => {
    setCarDetail(carDetails);
  }, [carDetails]);

  useEffect(() => {
    if (carDetail.carMake) {
      dispatch(getCarModal(carDetail.carMake));
    } else {
      dispatch(getCarModal());
    }
  }, [carDetail]);

  useEffect(() => {
    if (carDetails.carMake !== carDetail.carMake) {
      setCarDetail({ ...carDetail, carModel: "" });
    }
  }, [carDetail.carMake, carDetails]);
  //for seater

  // useEffect(() => {
  //   if (carDetails.carType !== carDetail.carType) {
  //     setCarDetail({ ...carDetail, carType: "" });
  //   }
  // }, [carDetail.carMake, carDetails]);

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // const handleRemove = () => {
  //   localStorage.removeItem("persist:root");
  // };

  const steps = [
    // "Personal Information",
    "Car Details",
    // "Driver's Details",
    "Rent Charges",
  ];

  useEffect(() => {
    // base64Data = {
    //     ...base64Data,
    //     identityFront: (personalDetail?.identityFront) ? base64StringToSyntheticFile(personalDetail?.identityFront) : userDetail?.data?.identityFront,
    //     identityBack: (personalDetail?.identityBack) ? base64StringToSyntheticFile(personalDetail?.identityBack) : userDetail?.data?.identityBack,
    //     carFrontImg: (carDetails?.carFrontImg) ? base64StringToSyntheticFile(carDetails?.carFrontImg?.base64) : "",
    //     carBackImg: (carDetails?.carBackImg) ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64) : "",
    //     carLeftImg: (carDetails?.carLeftImg) ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64) : "",
    //     carRightImg: (carDetails?.carRightImg) ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64) : "",
    //     numberPlateImg: (carDetails?.numberPlateImg) ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64) : "",
    //     IDfront: (driverDetails?.IDfront) ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64) : "",
    //     IDback: (driverDetails?.IDback) ? base64StringToSyntheticFile(driverDetails?.IDback?.base64) : "",
    //     licenceImg: (driverDetails?.licenceImg) ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64) : "",
    // }\

    setBase64Data({
      ...base64Data,
      identityFront: personalDetail?.identityFront
        ? base64StringToSyntheticFile(personalDetail?.identityFront)
        : userDetail?.data?.identityFront,
      identityBack: personalDetail?.identityBack
        ? base64StringToSyntheticFile(personalDetail?.identityBack)
        : userDetail?.data?.identityBack,
      // carFrontImg: (carDetails?.carFrontImg) ? base64StringToSyntheticFile(carDetails?.carFrontImg?.base64) : "",
      carFrontImg: carDetails?.carFrontImg
        ? carDetails.carFrontImg.base64
          ? base64StringToSyntheticFile(carDetails.carFrontImg.base64)
          : carDetails.carFrontImg
        : null,
      carSeatsImg: carDetails?.carSeatsImg
        ? carDetails.carSeatsImg.base64
          ? base64StringToSyntheticFile(carDetails.carSeatsImg.base64)
          : carDetails.carSeatsImg
        : "",
      carInteriorImg: carDetails?.carInteriorImg
        ? carDetails.carInteriorImg.base64
          ? base64StringToSyntheticFile(carDetails.carInteriorImg.base64)
          : carDetails.carInteriorImg
        : "",
      carDashboardImg: carDetails?.carDashboardImg
        ? carDetails.carDashboardImg.base64
          ? base64StringToSyntheticFile(carDetails.carDashboardImg.base64)
          : carDetails.carDashboardImg
        : "",
      carChassisImg: carDetails?.carChassisImg
        ? carDetails.carChassisImg.base64
          ? base64StringToSyntheticFile(carDetails.carChassisImg.base64)
          : carDetails.carChassisImg
        : "",
      diskImage: carInsurance?.diskImage
        ? carInsurance.diskImage.base64
          ? base64StringToSyntheticFile(carInsurance.diskImage.base64)
          : carInsurance.diskImage
        : "",

      // carBackImg: (carDetails?.carBackImg) ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64) : "",
      carBackImg: carDetails?.carBackImg
        ? carDetails.carBackImg.base64
          ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64)
          : carDetails?.carBackImg
        : "",
      carLeftImg: carDetails?.carLeftImg
        ? carDetails?.carLeftImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64)
          : carDetails?.carLeftImg
        : "",
      carRightImg: carDetails?.carRightImg
        ? carDetails?.carRightImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64)
          : carDetails?.carRightImg
        : "",
      numberPlateImg: carDetails?.numberPlateImg
        ? carDetails?.numberPlateImg?.base64
          ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64)
          : carDetails?.numberPlateImg
        : "",
      IDfront: driverDetails?.IDfront
        ? driverDetails?.IDfront?.base64
          ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64)
          : driverDetails?.IDfront
        : "",
      IDback: driverDetails?.IDback
        ? driverDetails?.IDback?.base64
          ? base64StringToSyntheticFile(driverDetails?.IDback?.base64)
          : driverDetails?.IDback
        : "",
      licenceImg: driverDetails?.licenceImg
        ? driverDetails?.licenceImg?.base64
          ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64)
          : driverDetails?.licenceImg
        : "",
      // carLeftImg: (carDetails?.carLeftImg) ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64) : "",
      // carRightImg: (carDetails?.carRightImg) ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64) : "",
      // numberPlateImg: (carDetails?.numberPlateImg) ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64) : "",
      // IDfront: (driverDetails?.IDfront) ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64) : "",
      // IDback: (driverDetails?.IDback) ? base64StringToSyntheticFile(driverDetails?.IDback?.base64) : "",
      // licenceImg: (driverDetails?.licenceImg) ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64) : "",
    });

    // setBase64Data({
    //     identityFront: (personalDetail?.identityFront) ? base64StringToSyntheticFile(personalDetail?.identityFront) : userDetail?.data?.identityFront,
    //     identityBack: (personalDetail?.identityBack) ? base64StringToSyntheticFile(personalDetail?.identityBack) : userDetail?.data?.identityBack
    // })
  }, [step, carDetails]);
  useEffect(() => {
    if (editCarResponse?.success === true) {
      toast(editCarResponse?.message);
      dispatch(cleanData());
      dispatch(clearEditCarID());
      dispatch(clearCarImagesResponse());

      navigate("/myvehicle");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCarResponse]);

  function base64StringToSyntheticFile(
    base64String,
    fileName = "image.png",
    fileType = "image/png"
  ) {
    if (base64String) {
      if (base64String.includes("base64")) {
        // Split the base64 string by comma to separate metadata from data
        const parts = base64String.split(",");
        // Extract the metadata part which contains the data type and base64 prefix
        const metadata = parts[0];
        // Split the metadata part by semicolon to separate data type and parameters
        const metadataParts = metadata.split(";");
        // Extract the data type which contains the MIME type and encoding
        const dataType = metadataParts[0];
        // Extract the file extension from the data type
        const extension = dataType.split("/")[1];

        fileType = dataType;
        fileName = `image.${extension}`;
        // Check if the base64 string contains a data URI prefix
        let str = base64String.substr(base64String.indexOf(",") + 1);
        // Log the base64 string before decoding

        // Convert base64 string to Blob
        const byteCharacters = atob(str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });

        // Create synthetic file object
        const syntheticFile = new File([blob], fileName, {
          type: fileType,
        });

        return syntheticFile;
      } else {
        return base64String;
      }
    }
  }
  function createCarHandler(pay) {
    if (
      carDetails.gpsAvaiblity === false ||
      carDetails.gpsAvaiblity === "false"
    ) {
      setBtnStatus(false);
    } else {
      setBtnStatus(true);
    }

    // if (step === 4) {
    if (step === 3) {
      const formData = new FormData();
      const {
        carFrontImg,
        carBackImg,
        carLeftImg,
        carRightImg,
        carInteriorImg,
        carSeatsImg,
        carDashboardImg,
        carChassisImg,
        numberPlateImg,
        IDfront,
        IDback,
        licenceImg,
        diskImage,
      } = carImagesResponse;

      // Append personal details
      if (PersonalDetails) {
        formData.append("role", 1);
        // formData.append("name", PersonalDetails.fullName || "");
        // formData.append("UserEmail", PersonalDetails.email || "");
        // formData.append(
        //   "UserPhoneNumber",
        //   PersonalDetails.userPhoneNumber || ""
        // );
        // formData.append(
        //   "user_country_code",
        //   PersonalDetails.userCountryCode || ""
        // );
        // formData.append("userId", PersonalDetails.userId || "");
        // formData.append("address", PersonalDetails.address || "");

        // formData.append("name", userDetail?.data?.name || "");
        // formData.append("UserEmail", userDetail?.data?.emailId || "");
        // formData.append(
        //   "UserPhoneNumber",
        //   userDetail?.data?.phoneNumber || ""
        // );
        // formData.append(
        //   "user_country_code",
        //   userDetail?.data?.country_code || ""
        // );
        formData.append("userId", userDetail?.data?._id);
        // formData.append("address", userDetail?.data?.address || "");

        // As Readonly fields so no need to conver pass direct same url of image

        // if (editCarID) {
        //   formData.append("carId", editCarID);
        //   formData.append(
        //     "userIdentitycardFront",
        //     base64Data.identityFront || ""
        //   );
        //   formData.append(
        //     "userIdentitycardBack",
        //     base64Data.identityBack || ""
        //   );
        // } else {
        //   formData.append("identityFront", base64Data.identityFront || "");
        //   formData.append("identityBack", base64Data.identityBack || "");
        // }
        if (editCarID) {
          formData.append("carId", editCarID);
        }
        // formData.append("identityFront", personalDetail?.identityFront);
        // formData.append("identityBack", personalDetail?.identityBack);
      }

      // Append car details
      if (carDetails) {
        formData.append("maker", carDetails.carMake || "");
        formData.append("model", carDetails.carModel || "");
        formData.append("carCategory", carDetails.carType || "");
        formData.append("yearOfManufacture", carDetails.manufactureYr || "");
        formData.append("registrationNumber", carDetails.registrationNum || "");
        formData.append("numberOfSeats", carDetails.seat || "");
        formData.append("mileage", carDetails.mileage || "");
        formData.append("fuelType", carDetails.fuelType || "");
        formData.append("motor", carDetails.motor || "");
        formData.append("topSpeed", carDetails.speed || "");
        formData.append("power", carDetails.power || "");
        if (carDetails.carFeature) {
          carDetails.carFeature.forEach((feature) => {
            formData.append("features", feature);
          });
        } else {
          formData.append("features", "");
        }
        // formData.append("features", carDetails.carFeature || '');
        formData.append("carLocation", carDetails.carLocation || "");
        formData.append("lat", location?.lat);
        formData.append("long", location?.lng);
        // formData.append("frontImage", base64Data.carFrontImg || "");
        // formData.append("seat_image", base64Data.carSeatsImg || "");
        // formData.append("interior_image", base64Data.carInteriorImg || "");
        // formData.append("dashboard_image", base64Data.carDashboardImg || "");
        // formData.append("chasis_image", base64Data.carChassisImg || "");
        // formData.append("disk_image", base64Data.diskImage || "");
        // formData.append("backImage", base64Data.carBackImg || "");
        // formData.append("leftImage", base64Data.carLeftImg || "");
        // formData.append("rightImage", base64Data.carRightImg || "");
        // formData.append("numberPlateImage", base64Data.numberPlateImg || "");
        formData.append("frontImage", carFrontImg);
        formData.append("seat_image", carSeatsImg);
        formData.append("interior_image", carInteriorImg);
        formData.append("dashboard_image", carDashboardImg);
        formData.append("chasis_image", carChassisImg);
        formData.append("disk_image", diskImage);
        formData.append("backImage", carBackImg);
        formData.append("leftImage", carLeftImg);
        formData.append("rightImage", carRightImg);
        formData.append("numberPlateImage", numberPlateImg);
        formData.append("withDriver", carDetails.driverToggle || false);
        // formData.append("driverAvailable", carDetails.driverToggle || false);
        formData.append("gpsPayment", gpsPayment?.data?.gpsPayment || 0);
      }
      // Append driver details
      // if (driverDetails) {
      //   formData.append("driverName", driverDetails.fullName || "");
      //   formData.append("driverAge", driverDetails.age || "");
      //   // formData.append("driverNumber", driverDetails.phone || "");
      //   formData.append("driverNumber", driverDetails.driverPhoneNumber || "");
      //   formData.append(
      //     "driver_country_code",
      //     driverDetails.driverCountryCode || ""
      //   );
      //   formData.append("driverEmail", driverDetails.email || "");
      //   formData.append("rent", driverDetails.driverRent || "");
      //   // formData.append("identityCardFrontSide", base64Data.IDfront || "");
      //   // formData.append("identityCardBackSide", base64Data.IDback || "");
      //   // formData.append("licenceCard", base64Data.licenceImg || "");
      //   // same sending image path for driver images
      //   formData.append("identityCardFrontSide", IDfront?IDfront:"");
      //   formData.append("identityCardBackSide", IDback?IDback:"");
      //   formData.append("licenceCard", licenceImg?licenceImg:"");
      //   formData.append(
      //     "licenceIssueDate",
      //     driverDetails.licenceIssueDate || ""
      //   );
      //   formData.append(
      //     "licenceExpiryDate",
      //     driverDetails.licenceExpiryDate || ""
      //   );
      //   formData.append("withDriver", driverDetails.withDriver || false);
      // }

      // Append insurance details
      if (carInsurance) {
        formData.append("pricePerDay", carInsurance.pricePerDay || "");
        formData.append("companyName", carInsurance.companyName || "");
        formData.append("policyNumber", carInsurance.policyNumber || "");
        formData.append("expiryDate", carInsurance.expiryDate || "");
        formData.append(
          "insuranceAvailable",
          carInsurance.insuranceAvailable || false
        );
      }
      if (carDetails.gpsAvaiblity === false) {
        // window.location = `https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${100}`
        // window.location = `https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${gpsPayment?.data?.gpsPayment}/${0}/${0}`;
        // const data = {
        //   amount: gpsPayment?.data?.gpsPayment,
        //   type: 0,
        //   device: 0,
        //   userId: userDetail?.data?._id,
        // };
        Swal.fire({
          title: "Do you want to add a GPS device?",
          text: "You have no GPS device. Do you want to add one?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, proceed to payment",
          cancelButtonText: "No, add without GPS",
          customClass: {
            confirmButton: "btn img-btn", // Custom class for confirm button
            cancelButton: "btn btn-danger", // Custom class for cancel button
          },
        }).then((result) => {
          console.log('result.isConfirmed', result?.isConfirmed)
          if (result.isConfirmed) {
            if (pay === "Lenco") {
              // PAYMENT BYPASS CODE

              // formData.append("gpsAvaiblity", true);
              // navigate(
              //   `/rentyourcar/verify_payment/1234`
              // );
              
              // if (editCarID) {
              //   dispatch(editCar({ data: formData })).then((res)=>{
              //     setAddResp(res);
              //   }).catch((error)=>{
              //     console.log(error)
              //   })
              // }else{
              //   dispatch(addCar({ data: formData })).then((res) => {
              //     setAddResp(res);
              //   });
              // }

              window?.LencoPay?.getPaid({
                key: process.env.REACT_APP_LENCO_PUBLIC_KEY, // Replace with your actual Lenco public key
                reference: "ref-" + Date.now(), // Generate a unique reference
                email: userDetail?.data?.emailId, // Customer's email address
                amount: gpsPayment?.data?.gpsPayment.toFixed(2), // Amount to be paid (in ZMW)
                currency: "ZMW", // Currency for the transaction
                channels: ["card", "mobile-money"],
                customer: {
                  firstName: "", // Customer's first name
                  lastName: "", // Customer's last name
                  phone: "", // Customer's phone number
                },
                onSuccess: (response) => {
                  // Callback when payment is completed successfully
                  const reference = response.reference;
                  formData.append("gpsAvaiblity", true);
                  // dispatch(addCar({ data: formData })).then((res) => {
                  //   setAddResp(res);
                  // });

                  if (editCarID) {
                    dispatch(editCar({ data: formData }))
                      .then((res) => {
                        setAddResp(res);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    dispatch(addCar({ data: formData })).then((res) => {
                      setAddResp(res);
                    });
                  }
                },
                onClose: () => {
                  // alert("Payment was not completed, window closed.");
                  // swal({
                  //   title: "Payment Cancelled",
                  //   text: "Your payment has been cancelled.",
                  //   icon: "error",
                  //   button: "OK",
                  // });
                  Swal.fire({
                    title: "Payment Cancelled",
                    text: "Your payment has been cancelled.",
                    icon: "error",
                    confirmButtonText: "OK",
                    customClass: {
                      confirmButton: "btn img-btn", // Custom class for the "OK" button
                    },
                    buttonsStyling: false, // Disable default SweetAlert2 styles for buttons
                  });
                },
                onConfirmationPending: (response) => {
                  if (editCarID) {
                    dispatch(editCar({ data: formData }))
                      .then((res) => {
                        setAddResp(res);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    dispatch(addCar({ data: formData })).then((res) => {
                      setAddResp(res);
                    });
                  }
                  navigate(
                    `/rentyourcar/verify_payment/${response?.reference}`,
                    {
                      state: { response },
                    }
                  );
                },
              });
            }
            // else {
            // stripe payment code
            // axios
            //   .post(`${baseURL}/pay/paynow`, data)
            //   .then((response) => {
            //     window.location = response?.data?.sessionUrl;
            //   })
            //   .catch((error) => {
            //     console.error("Error fetching contact data:", error);
            //   });
            // }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Show warning and add vehicle
            Swal.fire({
              icon: "warning",
              title: "⚠️ Proceeding without GPS",
              text: "You are proceeding without a GPS device at your own risk.",
              confirmButtonText: "Understood",
              confirmButtonColor: "#4caf50",
            }).then(() => {
              formData.append("gpsAvaiblity", carDetails.gpsAvaiblity || false);
              if (editCarID) {
                dispatch(editCar({ data: formData }))
                  .then((res) => {
                    setAddResp(res);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                dispatch(addCar({ data: formData })).then((res) => {
                  setAddResp(res);
                });
              }
            });
          }
        });
      } else {
        formData.append("gpsAvaiblity", carDetails.gpsAvaiblity || false);
        if (editCarID) {
          dispatch(editCar({ data: formData }))
            .then((res) => {
              setAddResp(res);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          dispatch(addCar({ data: formData })).then((res) => {
            setAddResp(res);
          });
        }
      }
      // handleRemove();
      // navigate('/')
      // dispatch(cleanData());
    }
  }
  async function verifyHandler(reference, data) {
    const interval = setInterval(async () => {
      try {
        const verifyResponse = await axios.get(
          `https://api.lenco.co/access/v2/collections/status/${reference}`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
            },
          }
        );

        if (
          verifyResponse?.data?.status &&
          verifyResponse?.data.data.status !== "pending"
        ) {
          clearInterval(interval); // Stop the interval if status is not "pending"
          if (verifyResponse?.data.data.status === "successful") {
            dispatch(addCar(data)).then((res) => {
              setAddResp(res);
            }); // Call your function if the status is "successful"
          } else {
            // Handle other statuses (if needed)
          }
        }
      } catch (error) {
        console.error("Error verifying status:", error);
        clearInterval(interval); // Stop the interval on error
      }
    }, 3000); // 3 seconds interval

    // Cleanup the interval if the component unmounts or reference changes
    // return () => clearInterval(interval);
  }

  useEffect(() => {
    if (addCarData?.success === true) {
      toast(addCarData?.message);
      dispatch(cleanData());
      setTimeout(() => {
        navigate("/myvehicle");
      }, 3000);
    } else {
      if (!Array.isArray(addCarData)) {
        // toast("Something went wrong");
        dispatch(cleanAddCarData());
      }
      setTimeout(() => {
        setBtnStatus(false);
      }, 5000);
    }
    if (addCarData?.success === false) {
      toast(addCarData?.message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCarData]);
  useEffect(() => {
    if (addResp?.payload) {
      toast(addResp?.payload[0]);
      setBtnStatus(false);
    }
  }, [addResp]);
  // useEffect(() => {

  //     return () => {
  //         if (editCarID) {
  //             dispatch(cleanData())
  //             dispatch(clearEditCarID());
  //         }
  //     }
  // }, [])

  return (
    <div className="container mt-3">
      <Form onSubmit={handleSubmit}>
        {/* {step === 4 ? null : ( */}
        {step === 3 ? null : (
          <>
            <div className="stepper-display">
              <Stepper activeStep={step} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
            <div className="prog-display">
              <ProgressBar now={(step / 3) * 100} />
            </div>
          </>
        )}
        {/* {step === 0 && (
          <Step>
            <PersonalDetail
              setPersonalDetail={setPersonalDetail}
              personalDetail={personalDetail}
            />
          </Step>
        )} */}
        {step === 1 && (
          <Step>
            <CarDetail CarDetail={carDetail} setCarDetail={setCarDetail} />
          </Step>
        )}
        {/* {step === 2 && (
          <Step>
            <CarFeature
              driverDetail={driverDetail}
              setDriverDetail={setDriverDetail}
              features={features}
              setFeatures={setFeatures}
            />
          </Step>
        )}
        {step === 3 && (
          <Step>
            <RentCharges />
          </Step>
        )} */}
        {step === 2 && (
          <Step>
            <RentCharges />
          </Step>
        )}
        <div>
          {/* {step === 4 && !carDetails?.gpsAvaiblity && ( */}
          {/* {step === 3 && !carDetails?.gpsAvaiblity && (
            <p className="text-danger">
              GPS is not available in the car. A GPS payment is required. Click
              the confirm submit button to proceed with the payment.
            </p>
          )} */}
        </div>
        <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
          {/* {step === 4 && ( */}
          {step === 3 && (
            <>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-none d-lg-block  px-5 img-btn  primaryColor"
              >
                {" "}
                Back{" "}
              </button>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-block d-lg-none px-3 img-btn  primaryColor"
              >
                <HiOutlineArrowLeft />
              </button>
            </>
          )}
          {/* {step === 4 && ( */}
          {step === 3 && (
            <div className="text-center ">
              {/* <img src={checkmark} className='img-fluid checkmark-img' />
                        <p className='text-secondary my-3' >Submitted Successfully!</p> */}
              {/* <button type="button" onClick={handleRemove} className="btn px-3 img-btn primaryColor"> DASHBAORD </button> */}
              {/* <div className="row row-gap-2 mt-5">
                <div className="col-12 col-sm-6">
                  <button
                    type="button"
                    onClick={createCarHandler}
                    className="btn px-3 img-btn primaryColor"
                    disabled={btnStatus}
                  >
                    Confirm Submit{" "}
                  </button>
                </div>
                <div className="col-12 col-sm-6">
                  <button
                    onClick={() => createCarHandler("Lenco")}
                    type="button"
                    className="btn img-btn primaryColor w-100"
                  >
                    Lenco Pay
                  </button>
                </div>
              </div> */}
              {/* <button
                type="button"
                // onClick={createCarHandler}  //it will for stripe
                onClick={() => createCarHandler("Lenco")}
                className="btn px-3 img-btn primaryColor"
                disabled={btnStatus}
              >
            
                Confirm Submit
              </button> */}
              {btnStatus ? (
                <ClipLoader color="#008080" loading className="mt-2" />
              ) : (
                <button
                  type="button"
                  // onClick={createCarHandler}  //it will for stripe
                  onClick={() => createCarHandler("Lenco")}
                  className="btn px-3 img-btn primaryColor"
                  disabled={btnStatus}
                >
                  Confirm Submit
                </button>
              )}
            </div>
          )}
        </div>
      </Form>
    </div>
  );
};

export default MultiStepForm;
